var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg89(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8699_2210)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.369091 7.01233C0.133683 7.23174 0 7.53908 0 7.86089V14.5002C0 15.4612 0.779025 16.2402 1.74 16.2402H4.96C6.06457 16.2402 6.96 15.3448 6.96 14.2402V12.7602C6.96 12.1196 7.47935 11.6002 8.12 11.6002C8.76064 11.6002 9.28 12.1196 9.28 12.7602V14.2402C9.28 15.3448 10.1754 16.2402 11.28 16.2402H14.5C15.4609 16.2402 16.24 15.4612 16.24 14.5002V7.86089C16.24 7.53908 16.1064 7.23174 15.8709 7.01233L8.49746 0.139876C8.28025 -0.0462995 7.95975 -0.0462998 7.74254 0.139876L0.369091 7.01233Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8699_2210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg89);
export default __webpack_public_path__ + "static/media/svg89.f202cb52ce387a74e4e0d314292c7604.svg";
export { ForwardRef as ReactComponent };